import ListFieldsGeneric from './ListFieldsGeneric'
let ListFields = ListFieldsGeneric('Kooperation')

export default {
  label: 'Kooperation',
  route: 'kooperation',
  className: 'kooperation',
  fields: [
    ListFields.SortableTimestamp('_updateDate', false, 'updateDate', true),
    ListFields.SortableTimestamp('_createDate', false, 'createDate', true),
    ListFields.SortableReference('organisationseinheit', false),
    ListFields.UnsortableReference('weitereOrganisationseinheiten', false),
    ListFields.UnsortableReference('ansprechpartner', true),
    ListFields.SortableField('titelKooperation', true),
    ListFields.SortableDate('beginn', false),
    ListFields.SortableDate('ende', false),
    ListFields.UnsortableReference('beteiligteOrganisationen', false)
  ]
}



// WEBPACK FOOTER //
// ./src/schema/list/Kooperation.js